import { Modal, Button } from 'antd';
import Loader from 'components/Loader';
import { useProposalContext } from 'context/proposal';

const DownloadingPDFModal = () => {
  const { downloadingPDFModal, setDownloadingPDFModal } = useProposalContext();

  const hideModal = () => {
    setDownloadingPDFModal(false);
  };

  if (!downloadingPDFModal) {
    return null;
  }

  return (
    <Modal
      className="simple-info-modal download-pdf-modal"
      centered
      visible
      closable={false}
      zIndex={1001}
      maskClosable={false}>
      <h3 className="title">Generating PDF</h3>
      <div className="divider" />

      <p className="body">
        <span>This might take a while</span>
      </p>

      <div className="spinner">
        <Loader />
      </div>

      <Button className="medium-btn grey-btn hide-btn" onClick={hideModal}>
        HIDE
      </Button>
    </Modal>
  );
};

export default DownloadingPDFModal;
